import React, { useState } from 'react'
import Logo from "../../../../styles/img/sb-logo.png"
import { UiTopNavBarWr, UiTopNavItem, UiMobileNavBar, UiHeaderLogo } from "./UiTopNavElements"

export default function TopNavBar(props) {
    const [isActive, setActive] = useState(false);
    const mobileSidebarToggle = () => {
        setActive(!isActive);
    }
    const toggleClose = () => {
        setActive(false);
    }

    return (
        <>
            <UiMobileNavBar toggle={mobileSidebarToggle} />
            <UiHeaderLogo logo={Logo}/>

            <UiTopNavBarWr isActive={isActive} close={toggleClose}>
                <UiTopNavItem label="Home" pathname={'home'} href="home"/>
                <UiTopNavItem label="How It Works" pathname={"how-it-works"}/>
                <UiTopNavItem label="Campaigns" pathname={'campaigns'} href="campaigns"/>
                <UiTopNavItem label="Learn" pathname={'learn'} href="learn"/>
                <UiTopNavItem label="Loyalty" pathname={'loyalty'} href="loyalty"/>
                <UiTopNavItem label="Shop" pathname={'shop'} href="shop"/>
                <UiTopNavItem label="Contact" pathname={'contact'}/>
            </UiTopNavBarWr>
            <UiTopNavBarWr isActive={isActive} close={toggleClose} >
                <UiTopNavItem
                    onClick={toggleClose}
                    label="Home"
                    pathname={"home"}
                />
                <UiTopNavItem
                    onClick={toggleClose}
                    label="Campaigns"
                    pathname={"ui/product-target-incentives"}
                />

                <UiTopNavItem
                    onClick={toggleClose}
                    label="Shop"
                    pathname={"shop/browse-products"}
                />

                <UiTopNavItem
                    onClick={toggleClose}
                    label="Points Bank"
                    pathname={"/app/points-banking"}
                />
                <UiTopNavItem
                    onClick={toggleClose}
                    label="Voucher Wallet"
                    pathname={"shop/voucher-wallet"}
                />
                <UiTopNavItem
                    onClick={toggleClose}
                    label="Help"
                    pathname={"help"}
                />
            </UiTopNavBarWr>
        </>
    )
}
